import React from 'react';
import './Archive.css';
import Category from './Category';
// import imageP from '../../public/image/cold.jpg'
// import imageP1 from '../../public/image/warm.jpg'
// import imageP2 from '../../public/image/products4.jpg'
// import imageP3 from '../../public/image/lader.png'
// import imageP4 from '../../public/image/shir.png'
// import imageP5 from '../../public/image/dariche.jpg'

const Archive = ({ categories }) => {


    return (
        <div className='categories-layer'>
            {
                categories.map(category =>
                    <Category
                        key={category._id}
                        _id={category._id}
                        imgSrc={category.image}
                        name={category.name}
                    />
                )
            }
        </div>
    );
}

export default Archive;